/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnInit, AfterViewInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../shared/loading-panel/loading-panel.service';
import { GenericModalService, ModalSettingsInput, ModalSettingsTemplate } from '../shared/generic-modal/generic-modal.service';
import { ToastService, ToastType } from '../shared/toast/toast.service';
import { PartnerComponentBase } from './partner-search-details.base';
import { PartnerCertificateService } from './services/partner-certificate.service';
import { PartnerCertificate, PartnerCertificateUsage, CertificateHandlerCheckResultContainer, CertificateHandlerParseResult, Partner } from './models';
import { CurrentUserService } from '../user/services/current-user.service';
import { DxDataGridModule, DxTagBoxModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoColumnFixingModule, DxiColumnModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { NgClass, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatetimePickerComponent } from '../shared/datetime-picker/datetime-picker.component';
import { BizUserColumnDirective } from '../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../shared/grid/biz-grid-date.directive';
import { BizGridFiltervalues } from '../shared/grid/biz-grid-filtervalues';

@Component({
    templateUrl: './partner-search-details-certificates.component.html',
    selector: 'ep-partner-details-certificates',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxTemplateModule, FormsModule, DatetimePickerComponent, DxTagBoxModule, NgClass, DatePipe, BizUserColumnDirective, BizDateColumnDirective]
})

export class PartnerSearchDetailsCertificatesComponent extends PartnerComponentBase implements OnInit, AfterViewInit {
    public bizGridFiltervalues = inject(BizGridFiltervalues);
    private partnerCertificateService = inject(PartnerCertificateService);
    private toastService = inject(ToastService);
    private modalService = inject(GenericModalService);
    private loadingPanelService = inject(LoadingPanelService);
    private currentUserService = inject(CurrentUserService);

    private partnerCertificatesAll: PartnerCertificate[] = []; // All certificates (internal and external combined)
    public partnerCertificatesInternal: PartnerCertificate[] = []; // Certificates handled/maintained internally in Link
    public partnerCertificatesExternal: PartnerCertificate[] = []; // Certificates maintained from an external system
    public partnerCertificateUsages: PartnerCertificateUsage[] = [];
    public certificateParseResult: CertificateHandlerParseResult;
    public parsedCertificateType: string;

    public allowUpdating = false;
    public allowDeleting = false;
    public allowDownload = false;

    public enableImportSaveButton = false;

    @ViewChild('showCertificates') showCertificatesTemplate: any;
    @ViewChild('certDataGrid') certDataGrid: any;

    ngOnInit() {
        this.checkPermissions();
    }

    ngAfterViewInit() {
        this.certDataGrid.instance.option('onEditorPreparing', (e: any) => this.setGridEditOptons(e));
    }

    async partnerSet(): Promise<any> {
        this.checkPermissions();
        await this.refresh();
    }

    isInternalPartner(partner: Partner): boolean {
        return partner?.PartnerType?.Name === 'Internal';
    }

    hasInternalPermission(partner: Partner): boolean {
        // For non-internal partners, ignore the 'internal' permission by always granting it.
        return !this.isInternalPartner(partner) || this.currentUserService.hasPermission('Partner_Action_InternalPartner');
    }

    checkPermissions() {
        const hasInternalPartnerPermission = this.hasInternalPermission(this.selectedPartner);
        this.allowUpdating = hasInternalPartnerPermission && this.currentUserService.hasPermission('Partner_Action_CertificateEdit');
        this.allowDeleting = hasInternalPartnerPermission && this.currentUserService.hasPermission('Partner_Action_CertificateDelete');
        this.allowDownload = hasInternalPartnerPermission && this.currentUserService.hasPermission('Partner_Action_CertificateDownload');
    }

    async refresh(): Promise<void> {
        const partnerId = this.selectedPartner?.PartnersId;

        this.partnerCertificatesExternal = [];
        this.partnerCertificatesInternal = [];

        this.partnerCertificatesAll = partnerId ? await this.partnerCertificateService.getCertificates(partnerId) : [];
        this.partnerCertificateUsages = await this.partnerCertificateService.getCertificateUsages();

        this.partnerCertificatesAll.forEach(pc => {
            pc.Usages = pc.Usages.map(u => this.partnerCertificateUsages.find(pcu => pcu.Id === u.Id));
        });

        this.updatePartnerCertificates();
    }

    updatePartnerCertificates() {
        this.partnerCertificatesExternal = this.partnerCertificatesAll.filter(c => c.ExternalForeignKey);
        this.partnerCertificatesInternal = this.partnerCertificatesAll.filter(c => !c.ExternalForeignKey);
    }

    async newCertificate(): Promise<void> {
        if (this.hasInternalPermission(this.selectedPartner)) {
            try {
                const files: File[] = await this.modalService.fileSelectorDirect('Select certificate', 'Select certificate file');
                if (files && files.length > 0) {
                    try {
                        this.loadingPanelService.showLoadingPanelDirect('Checking certificate...');
                        const result = await this.partnerCertificateService.uploadAndCheckCertificate(files[0]);
                        await this.handleCheckResult(result);
                    }
                    finally {
                        this.loadingPanelService.hideLoadingPanel();
                    }
                }
            }
            catch {
                //...
            }
        }
        else {
            this.toastService.showToast('Operation is not allowed on internal partners', ToastType.error);
        }
    }

    async handleCheckResult(result: CertificateHandlerCheckResultContainer): Promise<void> {
        try {
            if (result.CertificateProviderFound && result.OkCertificateCheckResult) {
                const password: string = result.OkCertificateCheckResult.PasswordNeeded
                    ? await this.askForPassword()
                    : undefined;
                await this.parseCheckResult(result, password);
            }
            else {
                await this.modalService.messageDirect('Invalid certificate', 'The given file could not be recognized as a valid certificate.');
            }
        }
        catch {
            //...
        }
    }

    async askForPassword(): Promise<string> {
        const inputSettings = new ModalSettingsInput('Private key password', 'The private key requires a password:');
        inputSettings.type = 'password';
        inputSettings.backdrop = 'static';
        return await this.modalService.input(inputSettings);
    }

    async parseCheckResult(checkResult: CertificateHandlerCheckResultContainer, password: string): Promise<void> {
        try {
            let parseResult: CertificateHandlerParseResult;
            try {
                this.loadingPanelService.showLoadingPanelDirect('Parsing certificate...');
                parseResult = await this.partnerCertificateService.parseCertificate(checkResult.CheckResultToken, password);
            }
            finally {
                this.loadingPanelService.hideLoadingPanel();
            }

            await this.handleParseResult(parseResult, checkResult);
        }
        catch {
            //...
        }
    }

    async handleParseResult(parseResult: CertificateHandlerParseResult, checkResult: CertificateHandlerCheckResultContainer): Promise<void> {
        // Make sure the correct partner-id is set
        parseResult.PartnerCertificates.forEach(c => c.PartnerId = this.selectedPartner?.PartnersId);

        try {
            switch (parseResult.Status) {
                case CertificateHandlerParseResult.ParseResultSuccess:
                    await this.showParsedCertificates(parseResult);
                    break;

                case CertificateHandlerParseResult.ParseResultWrongPassword: {
                    await this.modalService.messageDirect('Wrong password', 'Wrong password provided');
                    // If the password is wrong, just call the askForPassword again and then call the parseCheckResult again...
                    const password = await this.askForPassword();
                    await this.parseCheckResult(checkResult, password);
                    break;
                }

                case CertificateHandlerParseResult.ParseResultError:
                    await this.modalService.messageDirect('Invalid certificate',
                        'The file is not a valid certificate or the certificate-type is not supported. Status from server: ' + parseResult.StatusText);
                    break;
            }
        }
        catch {
            //...
        }
    }

    async showParsedCertificates(result: CertificateHandlerParseResult): Promise<void> {
        this.certificateParseResult = result;
        const settings = new ModalSettingsTemplate();
        settings.size = 'lg';
        settings.backdrop = 'static';

        // Just take the type from the first partner-certificate because they will all be of same type.
        this.parsedCertificateType = result.PartnerCertificates[0].CertificateType.Name;

        result.PartnerCertificates.forEach(c => {
            const alreadyImported = this.partnerCertificatesAll.some(pc => pc.HasPrivateKey === c.HasPrivateKey && pc.SerialNumber === c.SerialNumber);
            const isValid = new Date(c.ValidTo).getTime() >= new Date().getTime();

            c['alreadyImported'] = alreadyImported;
            c['isValid'] = isValid;
            c['isSelected'] = !alreadyImported && isValid && result.PartnerCertificates.length === 1;
        });

        this.onUpdateImportSaveButton();

        try {
            await this.modalService.openTemplate(this.showCertificatesTemplate, settings);

            const selectedCertificates = this.getSelectedImportedCertificates();
            if (selectedCertificates.length > 0) {
                try {
                    this.loadingPanelService.showLoadingPanelDirect('Saving certificates...');

                    await this.partnerCertificateService.commitUploadedCertificates(selectedCertificates, this.certificateParseResult.Token);
                    await this.refresh();
                }
                finally {
                    this.loadingPanelService.hideLoadingPanel();
                    this.toastService.showToast('Certificate(s) imported successfully...', ToastType.success);
                }
            }
        }
        catch {
            //...
        }
    }

    getCertificateStatus(certificate: PartnerCertificate): string {
        if (certificate['isValid'] === true) {
            if (certificate['alreadyImported'] === true) {
                return 'Imported';
            }
            else {
                return 'Ok';
            }
        }
        else {
            return 'Invalid';
        }
    }

    getSelectedImportedCertificates(): PartnerCertificate[] {
        return this.certificateParseResult.PartnerCertificates.filter(c => c['isSelected'] === true);
    }

    onUpdateImportSaveButton(): void {
        const selected = this.getSelectedImportedCertificates();

        const validSelection = selected.length > 0;
        const validUsages = !selected.some(e => !e.Usages || e.Usages.length < 1);
        const validDisplayName = !selected.some(e => e.ShowInPicker && !e.DisplayName);

        this.enableImportSaveButton = validSelection && validUsages && validDisplayName;
    }

    async onRowUpdating(e: any): Promise<void> {
        const deferred = $.Deferred(); // REVIEW: Fix this when Promise/Observable is fully supported by DevExpress
        e.cancel = deferred.promise();

        const clonedCertificate: PartnerCertificate = Object.assign({}, e.key); // Clone the certificate so we don't modify it before it's successfully saved
        Object.assign(clonedCertificate, e.newData); // Merge the new data to the clone

        // Validate clone before saving
        const invalidStart = (clonedCertificate.StartUsing < clonedCertificate.ValidFrom) || (clonedCertificate.StartUsing > clonedCertificate.ValidTo);
        if (invalidStart) {
            e.cancel = true;
            await this.modalService.messageDirect('Edit Row', 'The start date must be within the certificates valid period.');
            return;
        }
        if (clonedCertificate.ShowInPicker && !clonedCertificate.DisplayName) {
            e.cancel = true;
            await this.modalService.messageDirect('Edit Row', 'Display name is required when \'Show in picker\' is checked.');
            return;
        }
        if (!clonedCertificate.Usages?.length) {
            e.cancel = true;
            await this.modalService.messageDirect('Edit Row', 'At least one usage must be selected.');
            return;
        }

        // eslint-disable-next-line require-atomic-updates
        e.key = await this.partnerCertificateService.saveCertificate(clonedCertificate);

        deferred.resolve();
        this.toastService.showToast('Certificate saved...', ToastType.success);
    }

    async onRowRemoving(e: any): Promise<void> {
        const deferred = $.Deferred(); // REVIEW: Fix this when Promise/Observable is fully supported by DevExpress
        e.cancel = deferred.promise();

        await this.partnerCertificateService.deleteCertificate(e.data.Id);
        this.partnerCertificatesAll = this.partnerCertificatesAll.filter(c => c.Id !== e.data.Id);
        this.updatePartnerCertificates();

        deferred.resolve();
        this.toastService.showToast('Certificate deleted...', ToastType.success);
    }

    async downloadCertificate(certificate: PartnerCertificate): Promise<void> {
        try {
            this.loadingPanelService.showLoadingPanelDirect('Downloading...');
            await this.partnerCertificateService.downloadCertificate(certificate.Id);
        }
        finally {
            this.loadingPanelService.hideLoadingPanel();
        }
    }

    onToolbarPreparing(e) {
        if (this.currentUserService.hasPermission('Partner_Action_CertificateCreate')) {
            e.toolbarOptions.items.unshift({
                location: 'after',
                name: 'addNewCertificate',
                widget: 'dxButton',
                options: {
                    icon: 'add',
                    onClick: this.newCertificate.bind(this)
                }
            });
        }
    }

    setGridEditOptons(e) {
        if (e.parentType === 'dataRow' || e.parentType === 'filterRow') {

            if (e.dataField === 'StartUsing') {
                e.editorOptions.displayFormat = 'shortDateShortTime';
                e.editorOptions.type = 'datetime';
                e.editorOptions.min = e.row['data']['ValidFrom'];
            }
            if (e.dataField === 'Usages') {
                e.editorName = 'dxTagBox';
                e.editorOptions.placeholder = 'Select usages';
                e.editorOptions.dataSource = this.partnerCertificateUsages;
                e.editorOptions.showSelectionControls = true;
                e.editorOptions.displayExpr = 'Name';
                e.editorOptions.value = e.value || [];
                e.editorOptions.onValueChanged = args => e.setValue(args.value);
            }
        }
    }

    getUsagesFilterData: () => {text: any, value: any}[] = () =>
        this.partnerCertificatesInternal.flatMap(c => c.Usages)
            .filter((usage, index, self) => self.findIndex(u => u.Id === usage.Id) === index)
            .sort((a,b) => a.Name.localeCompare(b.Name))// Sort the usages alphabetically
            .map(e => ({ text: e.Name, value: e }));

    calculateUsagesFilterExpression(filterValue: PartnerCertificateUsage) {
        return (row: PartnerCertificate) => row.Usages.some(e => e.Id === filterValue.Id);
    }
}
